import { AbilityBuilder, createMongoAbility } from '@casl/ability'
const { can, build } = new AbilityBuilder(createMongoAbility);

export default function defineAbilityFor(user: any) {
    if (user) {
        if (user.temPermissao(['admin_automacao'])) {
            can('manage', 'AUTOMACAO')
            can('manage', 'DIARIO_OS')
            can('manage', 'OS_AUTOMACAO');
            return build()
        }

        if (user.temPermissao(['automacao_config'])) {
            can('config', 'AUTOMACAO');
        }

        if (user.temPermissao(['automacao'])) {
            can('read', 'AUTOMACAO');
            can('create', 'AUTOMACAO');
            can('create', 'DIARIO_OS', {
                area: 'AUTOMACAO'
            });
            can('create', 'EapOS', {
                area: 'AUTOMACAO'
            });
        }

        if (user.temPermissao(['site_manager'])) {
            can(['read', 'create'], 'OS_AUTOMACAO');
        }
    }

    return build()
}